(function() { window.GUID_3dc51b6f_a89f_42c0_81e9_2ba2b9c35003 = { getGuid: function() { return "3dc51b6f-a89f-42c0-81e9-2ba2b9c35003"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        class Snackbar {
            static Show(params, stack) {
                if (params != null) {
                    if (params.Id != null && params.Id.trim() != "") {
                        CS.Lag(10, () => {
                            const $previousSnackbar = $(".snackbar-container").last();
                            if (!stack && $previousSnackbar.length > 0) {
                                Snackbar.hide($previousSnackbar, () => {
                                    Snackbar.show(params, stack);
                                });
                            }
                            else {
                                Snackbar.show(params, stack);
                            }
                        });
                    }
                }
            }
            static show(params, stack) {
                const $snackbar = $(Snackbar.createElement(params, stack));
                $("#MasterContainer").append($snackbar);
                $snackbar.animate({ opacity: 1 }, 300, () => {
                    $snackbar.find(".snackbar").addClass("show");
                    CS.Lag(3000, () => {
                        Snackbar.hide($snackbar, () => { });
                    });
                });
                $snackbar.offon("click.snackbar", (e) => {
                    const $target = $(e.target);
                    //Aussi ben de fermer la snack peut importe ou tu click????
                    //if ($target.hasClass("snackbar__close-icon")) {
                    Snackbar.hide($snackbar, () => {
                        //params.onClose.call(this);
                    });
                    //}
                });
            }
            static hide($snackbar, callback) {
                if ($snackbar.length > 0) {
                    $snackbar.animate({ opacity: 0 }, 300, () => {
                        Snackbar.unbindClickEvent($snackbar);
                        $snackbar.remove();
                        callback.call(this);
                    });
                }
            }
            static createElement(params, stack) {
                let { Id: id, Type: type, Message: txt } = params;
                //if (txt) {
                //    txt = txt
                //        .replace(/\/u003c/gi, "<")
                //        .replace(/\/u003e/gi, ">")
                //        .replace(/\/u0027/gi, "'")
                //        .replace(/\/u0026/gi, "&");
                //}
                txt = this.decodeHtmlEntities(txt);
                let containerCssClass = "snackbar-container";
                let contentCssClass = "snackbar";
                let txtCssClass = "snackbar__txt";
                let closeIconCssClass = "snackbar__close-icon icon ic-cs-times";
                let containerMargin = "";
                switch (type) {
                    case "Danger":
                        contentCssClass += " snackbar__danger";
                        break;
                    case "Info":
                        contentCssClass += " snackbar__info";
                        break;
                    case "Success":
                        contentCssClass += " snackbar__success";
                        break;
                    case "Warning":
                        contentCssClass += " snackbar__warning";
                        break;
                    default:
                        break;
                }
                containerCssClass += " snackbar-container__bottom";
                containerCssClass += " snackbar-container__center";
                containerMargin = `style="margin-bottom: ${32}px"`;
                return `<div id="${id}" class="${containerCssClass}" ${containerMargin}>
                            <div class="${contentCssClass}">
                                <div class="${txtCssClass}">${CompuSport.decodeHTMLEntities(txt)}</div>
                                <div class="${closeIconCssClass}"></div>
                            </div>
                        </div>`;
            }
            static unbindClickEvent($snackbar) {
                $snackbar.off("click.snackbar");
            }
            static decodeHtmlEntities(str) {
                const txt = document.createElement('textarea');
                txt.innerHTML = str;
                return txt.value;
            }
        }
        Controls.Snackbar = Snackbar;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Snackbar.js.map
